module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-desktop-e0db0b8cfcbf62c7940cd07fb54ac41a.jpg";